import PolicyAmendmentPetitionDetail from './PolicyAmendmentPetitionDetail'

export default PolicyAmendmentPetitionDetail
